import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoSettingsChecks } from '../../../../contexts/ZitoneoContentContext';

const URLsCheck = () => {
    const translate = useTranslate();
    const { hasURLs, hasPrimaryURL, primaryIsEnabled } =
        useZitoneoSettingsChecks();

    const complete = hasURLs && hasPrimaryURL && primaryIsEnabled;
    const primaryDisabled = hasURLs && hasPrimaryURL && !primaryIsEnabled;
    const noPrimary = hasURLs && !hasPrimaryURL;

    const title = complete
        ? 'urls__complete'
        : primaryDisabled
        ? 'urls__primary_disabled'
        : noPrimary
        ? 'urls__no_primary'
        : 'urls__missing';

    const subtitle = complete
        ? 'urls__complete_subtitle'
        : primaryDisabled
        ? 'urls__primary_disabled_subtitle'
        : noPrimary
        ? 'urls__no_primary_subtitle'
        : 'urls__missing_subtitle';

    const icon = complete ? 'Check' : 'LinkOff';

    return (
        <li className='sidebar__quality_signal__item'>
            <div className='flex-column gap-8'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName={icon}
                        className={`quality_signal__item__icon --${
                            complete ? 'success' : 'warning'
                        }`}
                    />
                    <p>{translate(title)}</p>
                </div>
                <p>{translate(subtitle)}</p>
            </div>
        </li>
    );
};

export default URLsCheck;
